import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import UsersManagement from "../../Dashboard/Users/index";
import CompanySettings from "./CompanySettings/CompanySettings";
import DiscountLevel from "./CustomizerSettings/discountLevel/discountLevel";
import EmailFormat from "./emailFormat/emailFormat";
import Locations from "./locations/locations";
import PaymentTerms from "./paymentTerms/paymentTerms";
import SalesPersons from "./salesPersons/salesPersons";
import ShipmentMethods from "./shipmentMethods/shipmentMethods";
import WoStatuses from "./woStatuses/WoStatuses";
import TaxRate from "./taxRate/taxRate";

import AddEditUserLayout from "Dashboard/Users/AddEditUserLayout";
import Modal from "react-bootstrap/Modal";
import { useNavigate, useSearchParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";
import CompanyFiles from "./CompanyFiles/CompanyFiles";
import Couriers from "./Couriers/Couriers";
import PriceMatrix from "./CustomizerSettings/priceMatrix/priceMatrix";
import ArtworkLocation from "./CompanySettings/info/ArtworkLocation";
import EfsLicense from "./EfsLicense/EfsLicense";
import EmailClient from "./EmailClient/EmailClient";
import EmailSmtp from "./emailSmtp/EmailSmtp";
import ExportsLayout from "./Exports/ExportsLayout";
import Permissions from "./Permissions/Permissions";
import PortalUsers from "./portalUsers/PortalUsers";
import Security from "./Security/Security";
import Subscription from "./subscription/Subscription";

function Settings() {
  const user = useSelector((state) => state.user?.userInfo);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  /*   All States Below
   ********************************************* */
  const [active, setActive] = useState("company_info");
  const [showAddUser, setShowAddUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [showModal, setShowModal] = useState(false);
  // Only the accounts on the API's RFID_PUBLISH_USER_IDS allow-list can
  // publish. Ask the API rather than guessing from roles/permissions, and stay
  // silent when it says no -- a tile that leads to a locked page is noise.
  const [canPublishHandheld, setCanPublishHandheld] = useState(false);

  const hideModal = () => {
    setShowAddUser(false);
    setSelectedUser(null);
    setShowModal(false);
    setActive("");
  };

  useEffect(() => {
    let timeout = setTimeout(() => {
      let checkEmailGrant = searchParams.get("email_clients");
      if (checkEmailGrant === "true") {
        setActive("email_client");
        setShowModal(true);
      }
    }, 50);
    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    let cancelled = false;
    API.get("/rfid-publish/state", { headers: authHeader() })
      .then(() => {
        if (!cancelled) setCanPublishHandheld(true);
      })
      .catch(() => {
        if (!cancelled) setCanPublishHandheld(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="d-flex" style={{ minHeight: "90vh", marginLeft: 285 }}>
      <div className="d-flex flex-grow-1 flex-column">
        <h1 className="mt-5 mb-4">Settings</h1>
        <div className="d-flex justify-content-start align-items-center align-content-center gap-2 flex-wrap">
          {/*   paste here
           **********************************************/}
          {/* <div
            onClick={() => {
              setActive("subscription");
              setShowModal(true);
            }}
            className={`px-3 py-2 btn bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Subscription</div>
          </div> */}
          <div
            onClick={() => {
              setActive("company_info");
              setShowModal(true);
            }}
            className={`px-3 py-2 btn bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Company Info</div>
          </div>
          <div
            onClick={() => {
              setActive("security");
              setShowModal(true);
            }}
            className={`px-3 py-2 btn bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Security</div>
          </div>
          <div
            onClick={() => {
              setActive("locations");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Locations</div>
          </div>

          <div
            onClick={() => {
              setActive("user_management");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>User Management</div>
          </div>

          <div
            onClick={() => {
              setActive("portal_users");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Portal Users</div>
          </div>
          <div
            onClick={() => {
              setActive("sales_persons");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Sales Persons</div>
          </div>
          <div
            onClick={() => {
              setActive("payment_terms");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm `}
          >
            <div>Payment Terms</div>
          </div>
          <div
            onClick={() => {
              setActive("shipment_methods");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm `}
          >
            <div>Shipment Methods</div>
          </div>
          <div
            onClick={() => {
              setActive("wo_statuses");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm `}
          >
            <div>WO Statuses</div>
          </div>
          <div
            onClick={() => {
              setActive("couriers");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm `}
          >
            <div>Couriers</div>
          </div>

          <div
            onClick={() => {
              setActive("tax_rate");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm`}
          >
            <div>Tax Rate</div>
          </div>
          {/* Hidden per request -- to be deleted later, not currently in use */}
          <div
            onClick={() => {
              setActive("email_format");
              setShowModal(true);
            }}
            className={`d-none btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Email Template</div>
          </div>
          <div
            onClick={() => {
              setActive("company_files");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Company Attachments</div>
          </div>
          <div
            onClick={() => {
              setActive("exports");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Exports</div>
          </div>
          {(window.location.hostname === "localhost" ||
            window.location.hostname === "127.0.0.1") && (
            <div
              onClick={() => {
                setActive("permissions");
                setShowModal(true);
              }}
              className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
            >
              <div>Permissions</div>
            </div>
          )}
          {/* <div
            onClick={() => {
              setActive("email_client");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Nylas Email Accounts</div>
          </div> */}
          {/* <div
            onClick={() => {
              setActive("efs_license");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>EFS License</div>
          </div> */}
        </div>

        <h3 className="mt-5 mb-4">Customizer Setting</h3>
        <div className="d-flex justify-content-start align-items-center align-content-center gap-2 flex-wrap">
          <div
            onClick={() => {
              setActive("discount_level");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm  `}
          >
            <div>Discount Level</div>
          </div>
          <div
            onClick={() => {
              setActive("price_matrix");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm `}
          >
            <div>Price Matrix</div>
          </div>
        </div>

        {/* Its own section, not a card inside Company Info: the location is a
            machine setting for the ERP Artwork Manager desktop app, and
            buried under Company Address nobody found it. */}
        <h3 className="mt-5 mb-4">Artwork Manager</h3>
        <div className="d-flex justify-content-start align-items-center align-content-center gap-2 flex-wrap">
          <div
            onClick={() => {
              setActive("artwork_location");
              setShowModal(true);
            }}
            className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm `}
          >
            <div>Artwork Location</div>
          </div>
        </div>

        {/* Publishing JS bundles / APKs to the RFID handheld. Its own page
            rather than a modal: it uploads 50 MB files and has to stay open. */}
        {canPublishHandheld && (
          <>
            <h3 className="mt-5 mb-4">Handheld</h3>
            <div className="d-flex justify-content-start align-items-center align-content-center gap-2 flex-wrap">
              <div
                onClick={() => navigate("/settings/handheld-updates")}
                className={`btn px-3 py-2 bg-white shadow-sm custom-border-radius-sm `}
              >
                <div>
                  <i className="mdi mdi-cellphone-arrow-down me-1" />
                  Handheld Updates
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <Modal
        contentClassName="bg-transparent"
        size={
          active === "subscription"
            ? "md"
            : active === "company_info" ||
                active === "user_management" ||
                active === "couriers"
              ? "xl"
              : "lg"
        }
        centered
        show={showModal}
        onHide={() => {
          hideModal();
        }}
      >
        <Modal.Body className="bg-light px-3 py-3 pb-1 custom-border-radius">
          <div>
            {active === "subscription" && <Subscription />}
            {active === "company_info" && (
              <div className="tab-pane">
                <CompanySettings />
              </div>
            )}

            {active === "security" && (
              <div className="">
                <Security />
              </div>
            )}
            {active === "efs_license" && (
              <div className="">
                <EfsLicense />
              </div>
            )}

            {active === "user_management" &&
              (user?.permissions?.includes("user_add") ||
                user?.permissions?.includes("user_update") ||
                user?.permissions?.includes("user_delete") ||
                user?.roles === "admin") && (
                <div className="tab-pane">
                  {!showAddUser && (
                    <UsersManagement
                      setShowAddUser={setShowAddUser}
                      setSelectedUser={setSelectedUser}
                    />
                  )}
                  {showAddUser && (
                    <AddEditUserLayout
                      id={selectedUser?.id}
                      setShowAddUser={setShowAddUser}
                      setSelectedUser={setSelectedUser}
                      selectedUser={selectedUser}
                    />
                  )}
                </div>
              )}
            {active === "portal_users" && (
              <div className="tab-pane">
                <PortalUsers />
              </div>
            )}
            {active === "locations" && (
              <div className="tab-pane">
                <Locations />
              </div>
            )}
            {active === "payment_terms" && (
              <div className="tab-pane">
                <PaymentTerms />
              </div>
            )}
            {active === "shipment_methods" && (
              <div className="tab-pane">
                <ShipmentMethods />
              </div>
            )}
            {active === "wo_statuses" && (
              <div className="tab-pane">
                <WoStatuses />
              </div>
            )}
            {active === "couriers" && (
              <div className="tab-pane">
                <Couriers />
              </div>
            )}

            {active === "sales_persons" && (
              <div className="tab-pane">
                <SalesPersons />
              </div>
            )}

            {active === "tax_rate" && (
              <div className="tab-pane">
                <TaxRate />
              </div>
            )}
            {active === "email_format" && (
              <div className="tab-pane">
                <EmailFormat />
              </div>
            )}
            {active === "email_smtp" && (
              <div className="tab-pane">
                <EmailSmtp />
              </div>
            )}

            {active === "discount_level" && (
              <div className="tab-pane">
                <DiscountLevel />
              </div>
            )}
            {active === "artwork_location" && (
              <div className="tab-pane">
                <ArtworkLocation />
              </div>
            )}
            {active === "price_matrix" && (
              <div className="tab-pane">
                <PriceMatrix />
              </div>
            )}
            {active === "company_files" && (
              <div className="tab-pane">
                <CompanyFiles />
              </div>
            )}
            {active === "permissions" && (
              <div className="tab-pane">
                <Permissions />
              </div>
            )}
            {active === "exports" && (
              <div className="tab-pane">
                <ExportsLayout />
              </div>
            )}
            {active === "email_client" && (
              <div className="tab-pane">
                <EmailClient />
              </div>
            )}
          </div>
          <div className={`mt-3 mb-2 d-flex justify-content-end`}>
            <div>
              <button
                className="btn px-1 btn-secondary"
                type="button"
                onClick={() => {
                  setShowModal(false);
                  setActive("");
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Settings;
